import { BarnGrooveSize } from "@/types/preHang"
import { Common } from "@/util/common"

export class BarnGroove {
    public width: string
    public depth: string
    public type: 'standard' | 'custom'
    public isActive = false
    public quantity: number
    private widthOptions = Common.createMeasurementOptionsBySixteenths('1/16', '1/2', 30)
    private depthOptions = Common.createMeasurementOptionsBySixteenths('1/2', '2', 30)
    private sizeOptions = [
        {value: 'standard', label: 'Standard (1/4" x 3/4")'},
        {value: 'custom', label: 'Custom'}
    ]

    public constructor(active = false, quantity = 0, size: BarnGrooveSize = {width:'',depth:'',type:'standard'}) {
        this.isActive = active
        this.width = size.width
        this.depth = size.depth
        this.type = size.type
        this.quantity = quantity
    }

    public getWidthOptions() {
        return this.widthOptions
    }

    public getDepthOptions() {
        return this.depthOptions
    }

    public getSizeOptions() {
        return this.sizeOptions
    }

    public updateIsActive(isOpen:boolean) {
        this.isActive = isOpen
    }

    public updateQuantity(qty: number) {
        this.quantity = qty
    }

    public updateSize(size: BarnGrooveSize) {
        this.width = size.width
        this.depth = size.depth
        this.type = size.type
    }
}